export const OPEN_PLAN_DIALOG = "OPEN_PLAN_DIALOG";
export const CLOSE_PLAN_DIALOG = "CLOSE_PLAN_DIALOG";

export const GET_PLAN = "GET_PLAN";
export const CREATE_NEW_PLAN = "CREATE_NEW_PLAN";
export const EDIT_PLAN = "EDIT_PLAN";
export const DELETE_PLAN = "DELETE_PLAN";

export const SET_CREATE_PLAN_DONE = "SET_CREATE_PLAN_DONE";
export const UNSET_CREATE_PLAN_DONE = "UNSET_CREATE_PLAN_DONE";

export const SET_UPDATE_PLAN_DONE = "SET_UPDATE_PLAN_DONE";
export const UNSET_UPDATE_PLAN_DONE = "UNSET_UPDATE_PLAN_DONE";
